import ContactUsMenuItem from '@components/button/ContactSupportMenuItem'
import AppPaths from '@globals/paths'
import { colors } from '@globals/themes/defaultTheme'
import { TenantMember } from '@kudos/http-client'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import Divider from '@mui/material/Divider'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import Popover from '@mui/material/Popover'
import { SUPPORT_URL, TERMS_OF_SERVICE_URL } from '@shared/constants'
import { T } from '@transifex/react'
import { Link as RouterLink } from 'react-router'
import ViewProfileMenuItem from './ViewProfileMenuItem'

type TenantMemberAvatarPopoverProps = {
  onClose: () => void
  anchorEl: HTMLButtonElement | null
  member: TenantMember
}

const TenantMemberAvatarPopover: React.FC<TenantMemberAvatarPopoverProps> = ({
  onClose,
  anchorEl,
  member,
}) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      disableScrollLock
      slotProps={{
        paper: {
          sx: { minWidth: 220, pb: 1 },
        },
      }}>
      <ViewProfileMenuItem member={member} onClose={onClose} />
      <Divider />
      <MenuItem component={RouterLink} to={AppPaths.tenant.mySettings('general')} onClick={onClose}>
        <ListItemIcon>
          <SettingsOutlinedIcon fontSize="medium" />
        </ListItemIcon>
        <ListItemText primary={<T _str="My settings" />} />
      </MenuItem>
      <MenuItem component={RouterLink} to={AppPaths.logout()} onClick={onClose}>
        <ListItemIcon>
          <LogoutOutlinedIcon fontSize="medium" />
        </ListItemIcon>
        <ListItemText primary={<T _str="Log out" />} />
      </MenuItem>
      <ContactUsMenuItem onClose={onClose} />
      <MenuItem
        component={RouterLink}
        to={SUPPORT_URL}
        onClick={onClose}
        target="_blank"
        rel="noopener noreferrer">
        <ListItemText primary={<T _str="Help center" />} />
        <ListItemIcon sx={{ minWidth: '24px !important' }}>
          <OpenInNewIcon sx={{ color: `${colors.grayLight} !important` }} fontSize="medium" />
        </ListItemIcon>
      </MenuItem>
      <MenuItem
        component={RouterLink}
        to={TERMS_OF_SERVICE_URL}
        onClick={onClose}
        target="_blank"
        rel="noopener noreferrer">
        <ListItemText primary={<T _str="Terms of service" />} />
        <ListItemIcon sx={{ minWidth: '24px !important' }}>
          <OpenInNewIcon sx={{ color: `${colors.grayLight} !important` }} fontSize="medium" />
        </ListItemIcon>
      </MenuItem>
    </Popover>
  )
}

export default TenantMemberAvatarPopover
